<h3 mat-dialog-title>
    {{type}} Details
</h3>

<mat-dialog-content fxFlex>
    <busy-indicator *ngIf="!isLoaded" [big]="true"></busy-indicator>

    <ng-container *ngIf="isLoaded">
        <table mat-table [dataSource]="tableData" fxFill [formGroup]="formGroup">
            <ng-container matColumnDef="PostDate">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="postDateFilter" label="Post Date" placeholder="Post Date">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getPostDateTooltip(row)">
                        {{row.PostDate | date : 'M/d/yyyy'}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="SourceTransaction">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="sourceTransactionFilter" label="Source Transaction" placeholder="Source Transaction">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getSourceTransactionTooltip(row)">
                        <a *ngIf="hasInvoice(row)" (click)="goToInvoice(row)" aria-label="Redirect-Account">
                            {{getTextForColumn(row.SourceTransaction)}}
                        </a>
                        <ng-container *ngIf="!hasInvoice(row)">
                            {{getTextForColumn(row.SourceTransaction)}}
                        </ng-container>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Module">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="moduleFilter" label="Module" placeholder="Module">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getModuleTooltip(row)">{{row.Module}}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="descriptionFilter" label="Description" placeholder="Description">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getDescriptionTooltip(row)">
                        {{row.Description}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="EncumbranceDate">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="encumbranceDateFilter" label="Encumbrance Date" placeholder="Encumbrance Date">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getEncumbranceDateTooltip(row)">
                        {{row.EncumbranceDate | date: 'M/d/yyyy'}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Number">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="numberFilter" label="Number" placeholder="Number">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getNumberTooltip(row)">{{row.Number}}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="RequisitionNumber">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="requisitionNumberFilter" label="Requisition Number" placeholder="Requisition Number">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getRequisitionNumberTooltip(row)">{{row.RequisitionNumber}}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Amount">
                <th mat-header-cell *matHeaderCellDef>
                    <lgd-text controlName="amountFilter" label="Amount" placeholder="Amount">
                    </lgd-text>
                </th>
                <td mat-cell *matCellDef="let row">
                    <div [matTooltip]="getAmountTooltip(row)">{{row.Amount | currency}}</div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
            <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="pageSizes" [pageSize]="initialPageSize" showFirstLastButtons>
        </mat-paginator>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions fxLayout="column" fxLayoutAlign="end end">
    <button mat-button color="primary" mat-dialog-close telemetry="Submission-AccountDetailClose">
        Close
    </button>
</mat-dialog-actions>